module.exports = __webpack_public_path__ + "static/media/Header_admin_Mobile.678ba8aa.jpg";